
import { createFileRoute, redirect } from '@tanstack/react-router'
import { encountersQueryOptions } from '~/features/dashboard/pages/encounters/api/queries'
import { encountersLinkOptions } from '~/features/dashboard/pages/encounters/pages'
import { getApiProgram } from '~/lib/utils'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/encounters/')({
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(encountersQueryOptions({
      limit: 10,
      skip: 0,
      program: getApiProgram(params.program),
    }))
    context.queryClient.ensureQueryData(encountersQueryOptions({
      type: "appointment",
      limit: 10,
      skip: 0,
      program: getApiProgram(params.program),
    }))
    context.queryClient.ensureQueryData(encountersQueryOptions({
      type: "refill",
      limit: 10,
      skip: 0,
      program: getApiProgram(params.program),
    }))
  },
  beforeLoad: ({ params }) => {
    throw redirect(encountersLinkOptions(params.program))
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Encounters Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})


